import RepositoryTable from "./components/RepositoryTable";

function App() {
	return (
		<div >
			<RepositoryTable />
		</div>
	);
}

export default App;
